import React from "react";
import { useLang } from "../i18n";

// Replaces verbose "About" with a tight, human "How we think" block.
export default function Pillars() {
  const { t } = useLang();
  return (
    <section id="about" data-testid="pillars-section" className="relative py-24 md:py-36 border-t border-gt-cream/8">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-7">
            <div className="section-eyebrow mb-6">
              <span className="gt-eyebrow">{t.pillars.eyebrow}</span>
            </div>
            <h2 className="gt-display text-gt-cream text-4xl md:text-6xl lg:text-7xl">
              {t.pillars.title_a} <span className="text-gt-cream/55 gt-display-light">{t.pillars.title_em}</span>
            </h2>
          </div>
          <div className="lg:col-span-5 flex items-end">
            <p className="text-base md:text-lg text-gt-ink/75 leading-relaxed">
              {t.pillars.subtitle}
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-gt-cream/8">
          {t.pillars.items.map((p, i) => (
            <div key={i} className="bg-gt-bg p-7 md:p-8 min-h-[220px] flex flex-col" data-testid={`pillar-${i + 1}`}>
              <div className="font-display text-3xl text-gt-cream/40 mb-5">0{i + 1}</div>
              <h3 className="font-display text-2xl md:text-3xl text-gt-cream mb-3 uppercase leading-tight">{p.t}</h3>
              <p className="text-sm text-gt-ink/65 leading-relaxed mt-auto">{p.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
